import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=38300802&scoped=true&"
import script from "./VTable.vue?vue&type=script&lang=ts&"
export * from "./VTable.vue?vue&type=script&lang=ts&"
import style0 from "./VTable.vue?vue&type=style&index=0&id=38300802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38300802",
  null
  
)

export default component.exports